
import { getVuetify } from '@teamworksdev/vuetify';
import 'vuetify/styles';
import '@material-design-icons/font/round.css';
import '@material-design-icons/font/outlined.css';
import IconAppComplianceBlack from '@/components/icon/IconAppComplianceBlack.vue';

import { VBtn } from 'vuetify/components/VBtn';
import { VTooltip } from 'vuetify/components/VTooltip';
import { VCheckbox, VCheckboxBtn } from 'vuetify/components/VCheckbox';

import IconAppCompliancePlain from '@/components/icon/IconAppCompliancePlain.vue';

export const twDefaults = {
  VChipMini: {
    border: true,
    class: ['v-chip-mini', 'text-caption', 'font-weight-medium', 'px-1'],
    closeIcon: 'close',
    size: 'x-small',
    label: true,
    style: ['--v-activated-opacity: 0.03'],
  },
  VSelect: {
    bgColor: 'surface',
  },
  VBtnPrimary: {
    color: 'primary-button',
    elevation: 1,
    variant: 'flat',
  } as typeof VBtn.props,
  VBtnSecondary: {
    border: 'sm solid border-light opacity-100',
    class: 'text-decoration-none bg-background',
    elevation: 1,
    variant: 'outlined',
  } as typeof VBtn.props,
  VBtnDanger: {
    color: 'error',
    elevation: 1,
    variant: 'flat',
  } as typeof VBtn.props,
  VBtnText: {
    size: 'small',
    variant: 'text',
  } as typeof VBtn.props,
  VTooltip: {
    theme: 'dark',
    location: 'top',
  } as typeof VTooltip.props,
  VCheckbox: {
    theme: 'TwLight',
    color: 'info',
  } as typeof VCheckbox.props,
  VCheckboxBtn: {
    theme: 'TwLight',
    color: 'info',
  } as typeof VCheckboxBtn.props,

};

const vuetify = getVuetify({
  theme: {
    themes: {
      TwLight: {
        colors: {
          'axle-navbar-bottom': '#EAA934',
        },
      },
      TwDark: {
        colors: {
          'axle-navbar-bottom': '#EAA934',
        },
      },
    },
  },
  defaults: twDefaults,
  icons: {
    aliases: {
      'twi-app-compliance-black': IconAppComplianceBlack,
      'twi-app-compliance-plain': IconAppCompliancePlain,
    },
  },
});

export { vuetify };
